// Post-checkout return helpers (PLT-3715, folded-in PLT-4100).
//
// The Stripe success URL only carries `session_id`, not the purchased SKU, so
// we stash the selected SKU in sessionStorage right before redirecting out and
// read it back on return to show "what was bought". sessionStorage (not local)
// so it's scoped to the tab and naturally cleared when the tab closes.

const CHECKOUT_SKU_KEY = 'ssb_checkout_sku';

/** Query param Stripe appends on return: `?checkout=success|cancel`. */
export const CHECKOUT_RETURN_PARAM = 'checkout';
/** Stripe substitutes the real cs_... id into `?session_id=`. */
export const CHECKOUT_SESSION_PARAM = 'session_id';

export const CHECKOUT_RETURN_STATUS = {
  SUCCESS: 'success',
  CANCEL: 'cancel',
} as const;

export type CheckoutReturnStatus =
  (typeof CHECKOUT_RETURN_STATUS)[keyof typeof CHECKOUT_RETURN_STATUS];

/** Remember which SKU the user is buying, just before redirecting to Stripe. */
export const rememberCheckoutSku = (sku: string): void => {
  try {
    sessionStorage.setItem(CHECKOUT_SKU_KEY, sku);
  } catch {
    // Private-mode / storage-disabled: the confirmation just won't name the
    // plan — not worth failing the checkout over.
  }
};

/** Read the SKU stashed before checkout, or null if none / unavailable. */
export const readCheckoutSku = (): string | null => {
  try {
    return sessionStorage.getItem(CHECKOUT_SKU_KEY);
  } catch {
    return null;
  }
};

/** Clear the stashed SKU once it's been consumed (or checkout failed). */
export const clearCheckoutSku = (): void => {
  try {
    sessionStorage.removeItem(CHECKOUT_SKU_KEY);
  } catch {
    // no-op (see rememberCheckoutSku)
  }
};
